module.exports = __webpack_public_path__ + "img/icon-file-download.aac90c3f.svg";